import { ActivityFieldType } from "./ActivitiesSearch.types";

export const activityFieldTypeByFieldId: Record<string, ActivityFieldType> = {
    activity: ActivityFieldType.Text,
    id: ActivityFieldType.Text,
    type: ActivityFieldType.GeneralType,
    status: ActivityFieldType.Status,
    evaluation: ActivityFieldType.Evaluation,
    priority: ActivityFieldType.Priority,
    tags: ActivityFieldType.TagList,
    description: ActivityFieldType.Html,
    "sub-tasks": ActivityFieldType.SubTaskList,
    "documentation-required": ActivityFieldType.Boolean,
    "start-date": ActivityFieldType.Date,
    "end-date": ActivityFieldType.Date,
    recurrence: ActivityFieldType.Recurrence,
    "days-prior-to-notification": ActivityFieldType.Int,
    responsible: ActivityFieldType.EntityList,
    assignees: ActivityFieldType.EntityList,
    "approved-before-completed": ActivityFieldType.Approval,
    "business-areas": ActivityFieldType.BusinessAreaList,
    "group-companies": ActivityFieldType.EntityList,
    "compliance-areas": ActivityFieldType.ComplianceAreaList,
    contracts: ActivityFieldType.Contract,
    "external-contract-parties": ActivityFieldType.EntityList,
    "internal-contract-parties": ActivityFieldType.EntityList,
};
